import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion } from "framer-motion";

export default function Header({ branding, lang, setLang, t }) {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-[#D4AF37] bg-[#6B1F1F] shadow-lg">
      <div className="section-shell flex h-20 items-center justify-between gap-4">
        <Link
          to="/"
          className="flex items-center gap-3"
          onClick={() => setOpen(false)}
        >
          <img
            src={branding.logo.primary}
            alt={branding.logo.alt}
            className="h-12 w-auto"
          />
        </Link>

        <nav className="hidden items-center gap-2 lg:flex">
          {t.nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                isActive
                  ? "rounded-sur bg-[#D4AF37] px-4 py-2 text-sm font-black text-[#6B1F1F]"
                  : "rounded-sur px-4 py-2 text-sm font-bold text-white transition hover:bg-[#8B2E2E] hover:text-[#D4AF37]"
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            className="rounded-sur border border-[#D4AF37] bg-white px-3 py-2 text-sm font-bold text-[#6B1F1F]"
            onClick={() => setLang(lang === "en" ? "mr" : "en")}
          >
            {t.actions.language}
          </button>

          <button
            className="rounded-sur bg-[#D4AF37] px-3 py-2 text-sm font-bold text-[#6B1F1F] lg:hidden"
            onClick={() => setOpen((value) => !value)}
            aria-label="Open navigation"
          >
            ☰
          </button>
        </div>
      </div>

      {open && (
        <motion.nav
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          className="section-shell grid gap-2 pb-4 lg:hidden"
        >
          {t.nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                isActive
                  ? "rounded-sur bg-[#D4AF37] px-4 py-3 text-sm font-black text-[#6B1F1F]"
                  : "rounded-sur border border-[#D4AF37] bg-white px-4 py-3 text-sm font-bold text-[#6B1F1F]"
              }
            >
              {item.label}
            </NavLink>
          ))}
        </motion.nav>
      )}
    </header>
  );
}